import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA } from '../../../../../config/tables'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import { Grid, CardHeader, Card, CardContent, Typography } from '@material-ui/core'
import { blue400, blue800, green600, white } from '../../../../MaterialColorPicker/colors'

export class TablaCamionesSinDefinitivaView extends Component {
  render () {
    return (
      <div>
        <Grid container direction='column' spacing={2} alignItems='center'>
          <Typography variant='h5'>Cartas de Porte sin confirmación definitiva</Typography>
          <Grid
            item
            xs={12}
            sm={12}
            md={10}
            lg={8}
            xl={6}
            container
            spacing={4}
            justify='space-evenly'
          >
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <Card >
                <CardHeader style={{ background: green600, color: white }}
                  title='Estado'
                />
                <CardContent style={{ padding: '0 0 0 0' }}>
                  <Typography variant='h4'>
                    {this.props.estado}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <Card >
                <CardHeader style={{ background: blue400, color: white }}
                  title='Neto Origen'
                />
                <CardContent style={{ padding: '0 0 0 0' }}>
                  <Typography variant='h4'>
                    {this.props.pesoNetoOrigen} kgs
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <Card >
                <CardHeader style={{ background: blue800, color: white }}
                  title='Neto Descargado'
                />
                <CardContent style={{ padding: '0 0 0 0' }}>
                  <Typography variant='h4'>
                    {this.props.pesoNetoDescargado} kgs
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <MuiTable id={TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA} />
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}
